'use strict';
module.exports = require('../../full/instance/splice');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/features/instance/splice.js
// module id = 602
// module chunks = 13